/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ItineratorError,
  ItineratorGetPlatformsParams,
  ItineratorPlatform,
  ItineratorPlatformList,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Platforms<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Platform
   * @name GetPlatforms
   * @summary List all platforms
   * @request GET:/platforms
   * @secure
   */
  getPlatforms = (query?: ItineratorGetPlatformsParams, params: RequestParams = {}) =>
    this.request<ItineratorPlatformList, ItineratorError>({
      path: `/platforms`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Platform
   * @name GetPlatformBySlug
   * @summary Find a platform by slug
   * @request GET:/platforms/{slug}
   * @secure
   */
  getPlatformBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorPlatform, ItineratorError>({
      path: `/platforms/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
